module.exports = __webpack_public_path__ + "img/michele.baba78d5.jpg";